// extracted by mini-css-extract-plugin
export default {"preview":"LoaderPreview_preview__zJkQ4","noPreview":"LoaderPreview_noPreview__SZg3d"};